































import { Component, Vue, Watch } from "vue-property-decorator";
import OwnersListController from "./components/owners-list/OwnersListController.vue";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import AgroOnOff from "@/components/agroOnOff/AgroOnOff.vue";
import { OwnerFilter } from "@/api/owner/types";

@Component({
  name: "Owners",
  components: {
    AgroIcons,
    OwnersListController,
    AgroOnOff,
  },
})
export default class Owners extends Vue {
  private ownerFilter: OwnerFilter = {...this.ownerFilterStore};
  private mobileFilterModalVisible: boolean = false;


  private showFitersMobileModal() {
    this.mobileFilterModalVisible = true;
  }

  private closeFiterMobileModal() {
    this.mobileFilterModalVisible = false;
  }

  get ownerFilterStore() {
    return this.$store.state.owner.ownersFilter;
  }

  @Watch('ownerFilterStore')
  private onFilterChange(filter: OwnerFilter) {
    this.ownerFilter = this.ownerFilterStore;
  }

}
